import React, { useEffect, useState } from 'react';
import {
  HeaderContainer,
  HeaderContent,
  LogoSection,
  LogoMark,
  LogoTitle,
  NavigationSection,
  NavItem,
  AuthSection,
  AuthButton,
  ListSpaceButton,
} from './wrappers.ts';
import { useLocation, useNavigate } from 'react-router-dom';
import { TemporaryDrawer } from '../Drawer/index.tsx';
import { getToken } from '../../utils/authHelpers.ts';

const navItems = [
  { path: '/',                        label: 'Explore'        },
  { path: '/landing',                 label: 'For Colivings'  },
  { path: '/about',                   label: 'About'          },
  { path: '/questions-and-answers',   label: 'Q&A'            },
];

export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState(() => getToken());
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    setToken(getToken());
  }, [location]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (isMobile) {
    return (
      <HeaderContainer>
        <TemporaryDrawer />
      </HeaderContainer>
    );
  }

  return (
    <HeaderContainer>
      <HeaderContent>
        <LogoSection onClick={() => navigate('/')}>
          <LogoMark>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <circle cx="11" cy="11" r="11" fill="#C07848"/>
              <path d="M6 14 Q11 7 16 14" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round"/>
              <circle cx="11" cy="14" r="1.5" fill="white"/>
            </svg>
          </LogoMark>
          <LogoTitle>The Colivings</LogoTitle>
        </LogoSection>

        <NavigationSection>
          {navItems.map((item) => (
            <NavItem
              key={item.path}
              $isActive={location.pathname === item.path}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </NavItem>
          ))}
        </NavigationSection>

        <AuthSection>
          <ListSpaceButton onClick={() => navigate('/sign-up?role=owner')}>
            List your space
          </ListSpaceButton>
          <AuthButton onClick={() => navigate(token ? '/profile' : '/login')}>
            {token ? 'Profile' : 'Sign in'}
          </AuthButton>
        </AuthSection>
      </HeaderContent>
    </HeaderContainer>
  );
};
